/**
 * Tâches d'un utilisateur (`user_tasks`).
 *
 * Le préfixe des routes n'est pas homogène et le restera : la liste est
 * imbriquée sous l'utilisateur (`/api/users/:userId/tasks`), tout le reste
 * est à plat sous `/api/tasks`. C'est ce que le serveur expose ; le
 * regrouper ici évite d'avoir à s'en souvenir ailleurs.
 */
export const tasksEndpoints = {
  listForUser: (userId) => `/api/users/${userId}/tasks`,
  history: () => '/api/tasks/history',
  detail: (id) => `/api/tasks/${id}`,
  create: () => '/api/tasks',
  update: (id) => `/api/tasks/${id}`,
  delete: (id) => `/api/tasks/${id}`
}
